import { Scheduling, TariffGroupAttribute } from '@src/core/buyerApiClient';

import { buildLanguageOptions } from '@src/domains/products/features/product-booking/core/language/buildLanguageOptions';
import type { LanguageOption } from '@src/domains/products/features/product-booking/types/language';
import { LANGUAGE_ATTRIBUTE_TYPE } from '@src/domains/products/features/product-booking/types/attribute';
import {
  filterAttributesByTariffGroupIds,
  getTariffGroupIdsFromSchedulings,
  resolveSchedulingsForAttributes,
  schedulingsForTariffMountWithAttributes,
} from '@src/domains/products/scheduleHours/core/filterSchedulingsByAttributes';

export const buildLanguageOptionsForSchedulings = (
  attributes: TariffGroupAttribute[],
  schedulings: Scheduling[],
): LanguageOption[] => {
  const groupIds = getTariffGroupIdsFromSchedulings(schedulings);
  if (!groupIds.length) {
    return [];
  }

  return buildLanguageOptions(filterAttributesByTariffGroupIds(attributes, groupIds));
};

export const resolveSchedulingsForDateAndLanguage = (
  schedulings: Scheduling[],
  attributes: TariffGroupAttribute[],
  selectedLanguage: string | null,
): Scheduling[] =>
  resolveSchedulingsForAttributes(
    schedulings,
    attributes,
    selectedLanguage?.trim() ? [{ type: LANGUAGE_ATTRIBUTE_TYPE, value: selectedLanguage }] : [],
  );

/** Sold-out schedulings are only mounted once language is chosen (or when the date has no language step). */
export const schedulingsForTariffMount = (
  availables: Scheduling[],
  unavailables: Scheduling[],
  languageOptionsForDate: LanguageOption[] | undefined,
  selectedLanguage: string | null,
): Scheduling[] =>
  schedulingsForTariffMountWithAttributes(
    availables,
    unavailables,
    languageOptionsForDate?.length ? [{ type: LANGUAGE_ATTRIBUTE_TYPE, options: languageOptionsForDate }] : [],
    selectedLanguage?.trim() ? [{ type: LANGUAGE_ATTRIBUTE_TYPE, value: selectedLanguage }] : [],
  );
